import { render } from "./Platform.vue?vue&type=template&id=304a539e"
import script from "./Platform.vue?vue&type=script&lang=ts"
export * from "./Platform.vue?vue&type=script&lang=ts"
script.render = render

export default script